import { useState, useEffect } from 'react';
import api from '../../services/api';

export const usePersonaLibrary = (options = {}) => {
  const [personas, setPersonas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const {
    search = '',
    specialization = null,
    isActive = true,
    includeUsage = true
  } = options;

  useEffect(() => {
    const fetchPersonas = async () => {
      try {
        setLoading(true);
        const params = new URLSearchParams();

        if (search) params.append('search', search);
        if (specialization) params.append('specialization', specialization);
        if (isActive !== null) params.append('isActive', isActive);
        if (includeUsage !== null) params.append('includeUsage', includeUsage);

        const response = await api.get(`/admin/resources/personas?${params}`);
        console.log('Personas API response:', response.data);
        console.log('Personas count:', response.data.data?.length);
        console.log('First persona:', response.data.data?.[0]);
        setPersonas(response.data.data || []);
        setError(null);
      } catch (err) {
        setError(err);
        console.error('Error fetching personas:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchPersonas();
  }, [search, specialization, isActive, includeUsage]);

  return { personas, loading, error };
};
